import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import TableSelector from 'components/ui/form/dates/lib/TableSelector';

const MIN_DAY = 1, MIN_MONTH = 0, MAX_MONTH = 11;

/** Component to select a month in a table */
class MonthSelector extends Component {

    static propTypes = {
        textMenu:     PropTypes.string, // The text to show at the top menu
        defaultValue: PropTypes.number, // The default selected month
        onChange:     PropTypes.func, // Listener for when the selected month changes
        onClickTitle: PropTypes.func, // Listener for when the title has been clicked
        onClickMenu:  PropTypes.func, // Listener for when any menu button has been clicked
        selectedDate: PropTypes.number // The selected day to show
    };

    state = {
        defaultValue: undefined // The default month
    };

    /**
     * Init the state
     */
    componentWillMount() {
        const {defaultValue} = this.props;

        this.setState({
            defaultValue
        });
    }

    /**
     * Updates the state when the defaultValue has changed
     */
    componentWillReceiveProps(nextProps) {
        const {defaultValue} = nextProps;

        (nextProps.defaultValue !== defaultValue) && this.setState({
            defaultValue
        });
    }

    /**
     * Creates the array that contains the month data objects
     * @returns {Array} The array with the months
     */
    getMonths() {
        const
            ret = [],
            { intl:{formatDate}} = this.props,
            date = new Date();

        date.setDate(MIN_DAY);
        for (let i = MIN_MONTH; i <= MAX_MONTH; i++) {
            date.setMonth(i);
            const formattedDate = formatDate(date, {
                month: 'short'
            });

            ret.push({
                id:   i,
                text: formattedDate
            });
        }

        return ret;
    }

    render() {
        const
            {onChange, textMenu, onClickTitle, onClickMenu, selectedDate} = this.props,
            {defaultValue} = this.state;

        return (
            <TableSelector
                textMenu={textMenu}
                items={this.getMonths()}
                defaultValue={defaultValue}
                onChange={onChange}
                onClickTitle={onClickTitle}
                onClickMenu={onClickMenu}
                selectedDate={selectedDate}
            />
        );
    }
}


export default injectIntl(MonthSelector);



// WEBPACK FOOTER //
// ./src/components/ui/form/dates/month/MonthSelector.jsx